import { List } from "components/common/List/List";
import { Translate } from "components/common/Translate/Translate";
import { SortItem } from "../../../ControlBar/Sort/Sort";
import { useSort } from "../../../ControlBar/Sort/useSort";
import { type Sort as SortType, sorts } from "store/types/sort";
import type { ReactNode } from "react";

export const Sort = () => {
    const { handleClick, sort: currentSort } = useSort();

    return (
        <div className="flex flex-col overflow-hidden text-xl text-black border rounded-lg dark:text-white border-irGray-300 dark:border-darkSurface-400">
            <div className="px-6 py-2 font-semibold capitalize bg-white border-b dark:bg-darkSurface-200 border-b-irGray-400">
                <Translate keyName="mobile-sort-title" />:
            </div>
            <List callback={handleClick} items={getSortListItems(currentSort)} />
        </div>
    );
};

export const getSortListItems = (currentSort: SortType | null) =>
    sorts.reduce<Partial<Record<SortType, ReactNode>>>((acc, current, i) => {
        acc[current] = (
            <SortItem sort={current} currentSort={currentSort} isLast={i === sorts.length - 1}>
                <Translate keyName={current} />
            </SortItem>
        );
        return acc;
    }, {});
